// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__309ez","type":"styles_type__3ZMxG","choices":"styles_choices__Gj-0X"};